import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import BodyTypeWriteDTO from '../../../../../../types/body-type/BodyTypeWriteDTO';
import Media from '../../../../../../types/media/Media';
import { BodyTypeService } from '../../../../services/body-type.service';
import { MediaService } from '../../../../services/media.service';
import {
    SelectOrUploadMediaComponent
} from '../../media/select-or-upload-media-dialog/select-or-upload-media.component';

@Component({
    selector: 'app-update-body-type-dialog',
    templateUrl: './update-body-type-dialog.component.html',
    styleUrls: [ './update-body-type-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        SelectOrUploadMediaComponent,
    ]
})
export class UpdateBodyTypeDialogComponent implements OnChanges {
    @Input() visible: boolean = false;
    @Input() bodyType: BodyTypeWriteDTO = new BodyTypeWriteDTO({});
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() bodyTypeUpdated: EventEmitter<BodyTypeWriteDTO> = new EventEmitter<BodyTypeWriteDTO>();

    constructor(private bodyTypeService: BodyTypeService,
                private messageService: MessageService,
                private mediaService: MediaService) {
    }

    public loading = false;
    public media: Media | undefined = undefined;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue === true) {
            if (this.bodyType.iconId) {
                this.mediaService.getMedia(this.bodyType.iconId).then((media) => {
                    this.media = media;
                }).catch((error) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                });
            } else {
                this.media = undefined;
            }
        }
    }

    get saveDisabled(): boolean {
        return !this.bodyType?.name || !this.bodyType?.label;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public updateBodyType() {
        this.loading = true;
        if (this.media) {
            this.bodyType.iconId = this.media.id;
        } else {
            this.bodyType.iconId = undefined;
        }
        this.bodyTypeService.updateBodyType(this.bodyType).then(() => {
            this.bodyTypeUpdated.emit(this.bodyType);
            this.close();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        }).finally(() => {
            this.loading = false;
        });
    }
}
